module.exports = __webpack_public_path__ + "img/icon-baobiao.a0d141d3.png";